function waitForGsap(maxMs = 5000) {
  const start = Date.now()
  return new Promise((resolve) => {
    const tick = () => {
      const g = globalThis.gsap
      if (g) {
        resolve(g)
        return
      }
      if (Date.now() - start > maxMs) {
        resolve(null)
        return
      }
      requestAnimationFrame(tick)
    }
    tick()
  })
}

export default class ImageStack extends window.HTMLElement {
  #initStarted = false

  constructor() {
    super()
  }

  connectedCallback() {
    if (this.#initStarted) return
    this.#initStarted = true
    void this.#init()
  }

  async #init() {
    const gsap = await waitForGsap()
    if (!gsap) return

    this._gsap = gsap

    this.cards = Array.from(this.querySelectorAll('[data-rotation]'))
    this.cards.forEach((card, i) => {
      gsap.set(card, this.mapTransformPositions()[i])
    })

    if (this.cards.length < 2) return
    this.rotations = this.cards.map((card) => card.dataset.rotation)
    this.currentIndex = 0
    this.animating = false
    this.tranformPositions = this.mapTransformPositions()
    this.addEventListener('click', () => this.cycle())
  }

  mapTransformPositions() {
    return this.cards.map((card, i) => ({
      scale: 1 - i * 0.02,
      x: `${i * -10}%`,
      y: `${i * -8}%`
    }))
  }

  cycle() {
    const gsap = this._gsap
    if (!gsap || this.animating || !this.cards || this.cards.length < 2) return
    this.animating = true

    const total = this.cards.length
    const front = this.cards[this.currentIndex]
    const nextIndex = (this.currentIndex + 1) % total
    const backPosition = this.tranformPositions[total - 1]

    let remaining = total
    const tryFinish = () => {
      remaining -= 1
      if (remaining === 0) {
        this.currentIndex = nextIndex
        this.animating = false
      }
    }

    gsap.to(front, {
      rotation: this.rotations[total - 1],
      y: '-105%',
      x: backPosition.x,
      scale: 1 - (total - 1) * 0.01,
      duration: 0.4,
      ease: 'sine.inOut',
      onComplete: () => {
        front.style.zIndex = 1
        gsap.to(front, {
          ...backPosition,
          duration: 0.4,
          ease: 'sine.inOut',
          onComplete: tryFinish
        })
      }
    })

    for (let i = 0; i < total; i++) {
      if (i === this.currentIndex) continue

      const card = this.cards[i]
      const currentPos = this.getCardPosition(i)
      const newPos = currentPos - 1 < 0 ? total - 1 : currentPos - 1
      const newRotation = this.rotations[newPos]
      const newTransforms = this.tranformPositions[newPos]
      const newZ = total - newPos
      gsap.to(card, {
        ...newTransforms,
        rotation: newRotation,
        duration: 0.4,
        ease: 'power2.inOut',
        onComplete: () => {
          card.style.zIndex = newZ
          tryFinish()
        }
      })
    }
  }

  getCardPosition(cardIndex) {
    const total = this.cards.length
    const offset = (cardIndex - this.currentIndex + total) % total
    return offset
  }
}

window.customElements.define('image-stack', ImageStack)
